<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :z-index="10000000"
        background-color="#000"
        color="#fff"
      ></loading>
    </div>
    <div class="contentArea">
      <!-- <p>{{ paidList }}</p> -->
      <!-- <p>{{ selectedInvoice }}</p> -->
      <base-dialog :show="successModal" small>
        <div class="success my-10">
          <img src="../assets/success.svg" alt="" />
          <h2 class="mt-10 text-white">สร้างสำเร็จ</h2>
        </div>
      </base-dialog>
      <base-dialog :show="showDialog" @close="toggleDialog">
        <div class="px-8">
          <h2 class="text-center my-5">
            กรุณาเลือก Invoice ที่ต้องการออกใบเสร็จ
          </h2>
          <div class="grid grid-cols-12 gap-y-4 py-4 items-center">
            <h4>ผู้รับเงิน</h4>
            <select class="col-span-4" v-model="selectedAccoutingId" disabled>
              <option
                v-for="account in accountingList"
                :key="account.accounting_id"
                :value="account.accounting_id"
              >
                {{ account.acc_code }}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {{ account.name_th }}
              </option>
            </select>
            <h4 class="col-start-1">ชื่อลูกค้า</h4>
            <select
              class="col-span-4"
              @change="setCompany"
              v-model="modalCompany"
              disabled
            >
              <option
                v-for="member in memberList"
                :key="member.detail_id"
                :value="{ name: member.company_name, id: member.detail_id }"
              >
                {{ member.company_name }}
              </option>
            </select>
            <div
              class="col-start-10 col-span-3 grid grid-cols-4 text-right items-center"
            >
              <h4 class="mr-5">เดือน</h4>
              <select
                style="background-color: #4E5363"
                v-model="monthSelected"
                @change="loadSubTable"
              >
                <option value="0">ALL</option>
                <option v-for="month in monthList" :key="month">
                  {{ month }}
                </option>
              </select>
              <h4 class="mr-5">ปี</h4>
              <select
                style="background-color: #4E5363"
                v-model="yearSelected"
                @change="loadSubTable"
              >
                <option v-for="year in yearList" :key="year" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
          <ag-table
            :selectedInvoice="selectedInvoice"
            ref="invoiceTable"
            style="box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.09);"
          />
          <div class="grid grid-cols-8 gap-4 mt-5">
            <vs-button
              class="col-end-8"
              color="#ffffff"
              style="box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.09);"
              text-color="#8d9498"
              @click="toggleDialog"
            >
              ยกเลิก
            </vs-button>
            <vs-button
              class="col-end-9"
              button="submit"
              color="#15c1c3"
              @click="setSelectedInvoice"
            >
              บันทึก
            </vs-button>
          </div>
        </div>
      </base-dialog>
      <base-dialog :show="displayDeleteModal" small>
        <h2 class="text-center">ต้องการลบ Invoice นี้?</h2>
        <div class="grid grid-cols-8 gap-4 mt-5">
          <vs-button
            class="col-start-3 col-span-2"
            color="#ffffff"
            style="box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.09);"
            text-color="#8d9498"
            @click="displayDeleteModal = false"
          >
            ยกเลิก
          </vs-button>
          <vs-button class="col-span-2" color="#15c1c3" @click="deleteInvoice">
            บันทึก
          </vs-button>
        </div>
      </base-dialog>
      <form @submit.prevent="submitForm">
        <div class="card">
          <div class="grid grid-cols-2 gap-x-12 partition">
            <div class="grid grid-cols-5 gap-y-4 items-baseline box">
              <h4>ผู้รับเงิน</h4>
              <select
                class="col-span-4"
                v-model="selectedAccoutingId"
                @change="setCurrentAccount"
                disabled
              >
                <option
                  v-for="account in accountingList"
                  :key="account.accounting_id"
                  :value="account.accounting_id"
                  >{{ account.acc_code }}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ account.name_th }}
                </option>
              </select>
              <p class="">ที่อยู่</p>
              <textarea
                rows="3"
                class="col-span-4"
                :value="currentAccouting ? currentAccoutingAddress : ''"
                disabled
              />
              <p>Tax ID</p>
              <input
                type="text"
                class="col-span-4"
                :value="currentAccouting ? currentAccouting.tax_id : ''"
                disabled
              />
            </div>
            <div class="grid grid-cols-5 grid-rows-3 items-baseline box">
              <h4>บัญชีที่รับเงิน</h4>
              <select
                class="col-span-4"
                v-model="selectedAccountName"
                @change="setCurrentBankPaymentName()"
              >
                <option
                  v-for="bank in accountNameList"
                  :key="bank"
                  :value="bank"
                >
                  {{ bank }}</option
                >
              </select>
              <p class="">ธนาคาร</p>
              <select class="col-span-4" v-model="currentBank" required>
                <option
                  v-for="bank in currentBankList"
                  :key="bank.bankpayment_id"
                  :value="{
                    bankpayment_id: bank.bankpayment_id,
                    bank: bank.bank,
                    acc_number: bank.acc_number,
                  }"
                >
                  {{
                    bank.bank
                  }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                    bank.acc_number
                  }}
                </option>
              </select>
              <!-- <p>เลขบัญชี</p>
              <input
                type="text"
                class="col-span-4"
                :value="currentBank ? currentBank.acc_number : ''"
                disabled
              /> -->
            </div>
          </div>
          <div class="grid grid-cols-2 gap-x-12 partition">
            <div class="grid grid-cols-5 gap-y-4 items-baseline box">
              <p>ชื่อลูกค้า :</p>
              <input
                type="text"
                class="col-span-4"
                :value="currentMember ? currentMember.company_name : ''"
                disabled
              />
              <p class="">รายละเอียด :</p>
              <textarea
                rows="3"
                class="col-span-4"
                :value="currentMember ? currentMemberAddress : ''"
                disabled
              />
              <p>Tax ID :</p>
              <input
                type="text"
                class="col-span-4"
                :value="currentMember ? currentMember.tax_id : ''"
                disabled
              />
            </div>
            <div
              class="grid grid-cols-5 gap-y-4 auto-rows-min items-center box"
            >
              <p>วันที่ออก :</p>
              <div class="col-span-4">
                <v-date-picker
                  class="date-picker w-full"
                  is-dark
                  v-model="createDate"
                  is-required
                >
                  <template v-slot="{ inputEvents }">
                    <div class="date w-full">
                      <input
                        type="button"
                        class="date-input w-full text-left"
                        v-on="inputEvents"
                        :value="formattedCreateDate"
                      />
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </div>
          </div>
          <div
            :class="{ partition: !(selectedInvoice.length - 1 === index) }"
            v-for="(invoice, index) in selectedInvoice"
            :key="index"
          >
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <div class="task-no mr-10">
                  <h3 class="text-white">No.{{ index + 1 }}</h3>
                </div>
                <h3 class="text-white font-normal">
                  ใบแจ้งหนี้ เลขที่ {{ invoice.invoice_code }}
                </h3>
              </div>
              <div>
                <div class="bin-icon" @click="removeInvoice(index)">
                  <font-awesome-icon
                    icon="trash-alt"
                    :style="{ color: '#ff4a3d' }"
                  />
                </div>
              </div>
            </div>
            <div class="grid grid-cols-12 text-white table-header">
              <div class="col-span-1 grid grid-cols-2 justify-items-center">
                <div>
                  <vs-checkbox
                    color="#57c293"
                    :value="allSetPaid(index)"
                    :disabled="allPaid(index)"
                    @change="setAllPaid(index, $event)"
                  ></vs-checkbox>
                </div>
                <p>ลำดับ</p>
              </div>
              <div class="col-span-7">
                <p>รายละเอียด</p>
              </div>
              <div class="col-span-2">
                <p>ภาษีหัก ณ ที่จ่าย</p>
              </div>
              <div class="col-span-1">
                <p>ราคา (บาท)</p>
              </div>
            </div>
            <div class="table-info">
              <div
                class="grid grid-cols-12 text-white items-center table-item"
                v-for="(task, subidx) in invoice.taskToinvoice"
                :key="subidx"
              >
                <div class="col-span-1 grid grid-cols-2  justify-items-center">
                  <div>
                    <vs-checkbox
                      v-if="task.task.isPaid"
                      color="#57c293"
                      :value="true"
                      disabled
                    ></vs-checkbox>
                    <vs-checkbox
                      v-else
                      color="#57c293"
                      v-model="paidList[index].paid[subidx].value"
                    ></vs-checkbox>
                  </div>
                  <p>{{ subidx + 1 }}</p>
                </div>
                <div class="col-span-7">
                  <p>
                    {{ task.task.task_name }}
                    {{ taskDateFormat(task.task.task_name, task.task.date) }}
                  </p>
                </div>
                <div class="col-span-1 text-center">
                  <p>{{ task.task.tax ? task.task.tax + "%" : "-" }}</p>
                </div>
                <div class="col-start-11 col-span-2">
                  <p>{{ numberComma(task.task.price.toFixed(2)) }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="partition">
            <vs-button color="#15c1c3" class="w-full" @click="toggleDialog"
              >เพิ่ม / แก้ไขใบแจ้งหนี้
            </vs-button>
          </div>
          <div class="flex items-center mb-10">
            <p>หมายเหตุ : ภาษีมูลค่าเพิ่มชำระเกินสะสม</p>
            <!-- <input
              class="ml-3 mr-3"
              style="width: 100px"
              v-model.number="noteTax"
              type="number"
              step="0.01"
            /> -->
            <vue-numeric
              class="ml-3 mr-3 input-box"
              separator=","
              precision="2"
              v-model.number="noteTax"
              :disabled="invoiceStatus === 'ยกเลิก'"
            >
            </vue-numeric>
            <p>บาท รอนำไปหักภาษีขายเดือนถัดไป</p>
          </div>
          <div class="grid grid-cols-2 gap-x-10 grid-rows-2">
            <div class="grid grid-cols-5">
              <p>หมายเหตุ :</p>
              <textarea
                class="w-full col-span-4"
                rows="10"
                placeholder="หมายเหตุ"
                v-model="note"
              ></textarea>
            </div>
            <div class="grid grid-cols-2 gap-y-2 row-span-2 auto-rows-min">
              <div class="col-span-2">
                <div class="grid grid-cols-12">
                  <p class="col-span-3">วิธีการชำระเงิน</p>
                  <select class="col-span-9" v-model="payMethod">
                    <option value="โอนเงิน">โอนเงิน</option>
                    <option value="เช็ค">เช็ค</option>
                  </select>
                </div>
              </div>
              <div class="col-span-2">
                <div v-if="payMethod === 'เช็ค'" class="grid grid-cols-12">
                  <p class="col-span-3">ธนาคาร</p>
                  <select class="col-span-9" v-model="chequeBank" required>
                    <option
                      v-for="name in bankNameList"
                      :key="name"
                      :value="name"
                    >
                      {{ name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-span-2">
                <div v-if="payMethod === 'เช็ค'" class="grid grid-cols-12">
                  <p class="col-span-3">เลขที่เช็ค</p>
                  <input
                    class="col-span-9 text-left"
                    type="text"
                    v-model="chequeNumber"
                    required
                  />
                </div>
              </div>
              <div v-if="payMethod === 'เช็ค'" class="col-span-2">
                <div class="grid grid-cols-12">
                  <p class="col-span-3">วันที่</p>
                  <div class="col-span-9">
                    <v-date-picker
                      class="date-picker w-full"
                      is-dark
                      v-model="chequeDate"
                      is-required
                    >
                      <template v-slot="{ inputEvents }">
                        <div class="date w-full">
                          <input
                            type="button"
                            class="date-input w-full text-left"
                            v-on="inputEvents"
                            :value="formattedChequeDate"
                          />
                        </div>
                      </template>
                    </v-date-picker>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-2 col-span-2 summary items-baseline">
                <p class="my-2">จำนวนเงินรวม</p>
                <p class="text-right">{{ totalPrice }}</p>
                <p class="my-2">ภาษีหัก ณ ที่จ่าย</p>
                <p class="text-right">{{ totalTax }}</p>
                <p class="my-2">ยอดสุทธิ</p>
                <p class="text-right">{{ totalNet }}</p>
                <div
                  style="border-bottom: 1px solid #ffffff"
                  class="col-span-2"
                ></div>
                <p class="my-6">ชำระมาแล้ว</p>
                <input
                  class="my-6"
                  type="number"
                  step="0.01"
                  id="summary-input"
                  v-model.number="amount"
                />
                <div
                  style="border-bottom: 1px solid #ffffff"
                  class="col-span-2"
                ></div>
                <div>
                  <p class="mt-4">ผลต่าง</p>
                  <select id="summary-select" v-model="difference">
                    <option value="ค่าธรรมเนียมธนาคาร"
                      >ค่าธรรมเนียมธนาคาร</option
                    >
                    <option value="เงินขาด/เงินเกิน">เงินขาด/เงินเกิน</option>
                  </select>
                </div>
                <input
                  class="self-center mt-8 text-white"
                  type="number"
                  id="summary-input"
                  v-model.number="differenceValue"
                  disabled
                />
              </div>
              <div class="grid grid-cols-2 col-span-2 mt-2">
                <vs-checkbox
                  v-model="useAuthorize"
                  color="#15c1c3"
                  :disabled="
                    currentAccouting ? !currentAccouting.authorize : false
                  "
                  ><p>
                    ผู้อนุมัติ:
                    {{ currentAccouting ? currentAccouting.authorize : "" }}
                  </p></vs-checkbox
                >
              </div>
            </div>
          </div>
        </div>
        <div class="grid grid-cols-10 gap-4">
          <vs-button
            class="col-end-10 mt-5 mb-8"
            color="#ffffff"
            text-color="#8d9498"
            @click="goBackPage"
            >ยกเลิก</vs-button
          >
          <vs-button class="col-end-11 mt-5 mb-8" button="submit" color="#15c1c3"
            >บันทึก</vs-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import baseUrl from "../util/backend.js";
import AgTable from "../views/elements/ag-grid-table/table_component/tableOnly";
import moment from "moment";
import VueNumeric from "vue-numeric";

export default {
  components: {
    AgTable,
    Loading,
    VueNumeric,
  },
  data() {
    return {
      isLoading: false,
      successModal: false,
      displayEditModal: false,
      displayDeleteModal: false,
      showDialog: false,
      paidList: [],
      accountingList: [],
      bankPaymentList: [],
      memberList: [],
      modalCompany: null,
      monthSelected: 0,
      yearSelected: new Date().getFullYear(),
      monthList: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      yearList: [
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
      ],
      bankNameList: [
        "SCB",
        "BBL",
        "KBANK",
        "UOB",
        "BAY",
        "KTB",
        "TMB",
        "TBANK",
        "CIMB",
        "LH",
      ],
      currentAccouting: null,
      selectedAccountName: null,
      selectedAccoutingId: null,
      currentBankList: [],
      currentBank: null,
      currentMember: null,
      createDate: new Date(),
      noteTax: null,
      note: "",
      payMethod: "โอนเงิน",
      chequeBank: null,
      chequeNumber: null,
      chequeDate: null,
      amount: 0,
      difference: "ค่าธรรมเนียมธนาคาร",
      differenceValue: 0,
      useAuthorize: false,
    };
  },
  watch: {
    totalNet() {
      this.amount = this.totalNet.replace(/\,/g, "");
    },
    amount() {
      this.differenceValue = (
        this.amount - this.totalNet.replace(/\,/g, "")
      ).toFixed(2);
    },
    selectedInvoice() {
      this.setPaidList();
    },
    accountingList() {
      this.setCurrentAccount();
    },
    payMethod() {
      if (this.payMethod === "โอนเงิน") {
        this.chequeBank = null;
        this.chequeNumber = null;
        this.chequeDate = null;
      } else {
        this.chequeNumber = null;
        this.chequeDate = new Date();
      }
    },
    selectedInvoice() {
      this.setPaidList();
    },
  },
  computed: {
    currentAccoutingAddress() {
      return this.currentAccouting.province === "กรุงเทพมหานคร"
        ? this.currentAccouting.address +
            " เขต" +
            this.currentAccouting.subdistrict +
            " แขวง" +
            this.currentAccouting.district +
            " " +
            this.currentAccouting.province +
            " " +
            this.currentAccouting.postcode
        : this.currentAccouting.address +
            " ต." +
            this.currentAccouting.subdistrict +
            " อ." +
            this.currentAccouting.district +
            " จ." +
            this.currentAccouting.province +
            " " +
            this.currentAccouting.postcode;
    },
    currentMemberAddress() {
      return this.currentMember.province === "กรุงเทพมหานคร"
        ? this.currentMember.address +
            " เขต" +
            this.currentMember.subdistrict +
            " แขวง" +
            this.currentMember.district +
            " " +
            this.currentMember.province +
            " " +
            this.currentMember.postcode
        : this.currentMember.address +
            " ต." +
            this.currentMember.subdistrict +
            " อ." +
            this.currentMember.district +
            " จ." +
            this.currentMember.province +
            " " +
            this.currentMember.postcode;
    },
    // selectedInvoice() {
    //   return this.$store.getters["create/getSelectedInvoice"];
    // },
    // sortedSelectedInvoice() {
    //   return this.invoiceSort(this.selectedInvoice)
    // },
    selectedInvoice() {
      return this.invoiceSort(this.$store.getters["create/getSelectedInvoice"]);
    },
    accountNameList() {
      const accountList = [];
      for (const account of this.bankPaymentList) {
        if (!accountList.includes(account.acc_name)) {
          accountList.push(account.acc_name);
        }
      }
      return accountList;
    },
    formattedCreateDate() {
      return moment(this.createDate).format("DD/MM/YYYY");
    },
    formattedChequeDate() {
      return moment(this.chequeDate).format("DD/MM/YYYY");
    },
    totalPrice() {
      let price = 0;
      for (let i = 0; i < this.paidList.length; i++) {
        for (let j = 0; j < this.paidList[i].paid.length; j++) {
          if (this.paidList[i].paid[j].value === true) {
            price = price + this.selectedInvoice[i].taskToinvoice[j].task.price;
          }
        }
      }
      return this.numberComma(price.toFixed(2));
    },
    totalTax() {
      let price = 0;
      for (let i = 0; i < this.paidList.length; i++) {
        for (let j = 0; j < this.paidList[i].paid.length; j++) {
          if (this.paidList[i].paid[j].value === true) {
            price =
              price +
              (this.selectedInvoice[i].taskToinvoice[j].task.tax *
                this.selectedInvoice[i].taskToinvoice[j].task.price) /
                100;
          }
        }
      }
      return this.numberComma(price.toFixed(2));
    },
    totalNet() {
      let net = 0;
      for (let i = 0; i < this.paidList.length; i++) {
        for (let j = 0; j < this.paidList[i].paid.length; j++) {
          if (this.paidList[i].paid[j].value === true) {
            net =
              net +
              (this.selectedInvoice[i].taskToinvoice[j].task.price -
                (this.selectedInvoice[i].taskToinvoice[j].task.price *
                  this.selectedInvoice[i].taskToinvoice[j].task.tax) /
                  100);
          }
        }
      }
      return this.numberComma(net.toFixed(2));
    },
  },
  methods: {
    invoiceSort(arr) {
      const newArray = [];
      if (this.$store.getters["create/getSelectedInvoice"].length === 1) {
        for (const invoice of arr) {
          newArray.push({
            invoice_code: invoice.invoice_code,
            detail_id: invoice.detail_id,
            accounting_id: invoice.accounting_id,
            net: invoice.net,
            taskToinvoice: this.groupData(invoice.taskToinvoice),
          });
        }
      } else {
        for (const invoice of arr) {
          newArray.push({
            invoice_code: invoice.invoice_code,
            net: invoice.net,
            taskToinvoice: this.groupData(invoice.taskToinvoice),
          });
        }
      }
      return newArray;
    },
    groupData(arr) {
      const forSort = [];
      for (let i = 0; i < arr.length; i++) {
        forSort.push({
          index: i,
          task_name: arr[i].task.task_name,
          date: arr[i].task.date,
        });
      }
      let groupDate = _.groupBy(forSort, "date");
      groupDate = Object.keys(groupDate)
        .sort()
        .reduce((obj, key) => {
          obj[key] = groupDate[key];
          return obj;
        }, {});
      const group = [];
      for (var key in groupDate) {
        if (groupDate.hasOwnProperty(key)) {
          group.push(groupDate[key]);
        }
      }
      let accservice = [];
      let otherTask = [];
      for (var i = 0; i < group.length; i++) {
        for (var j = 0; j < group[i].length; j++) {
          if (group[i][j].task_name === "ค่าบริการบัญชี") {
            accservice.push(group[i][j]);
          } else {
            otherTask.push(group[i][j]);
          }
        }
        group[i] = accservice.concat(otherTask);
        accservice = [];
        otherTask = [];
      }
      let merged = [].concat.apply([], group);
      console.log("merged", merged);
      const fullArray = [];
      for (const task of merged) {
        fullArray.push(arr[task.index]);
      }
      return fullArray;
    },
    setAllPaid(index, e) {
      for (let i = 0; i < this.paidList[index].paid.length; i++) {
        console.log("set all");
        if (!this.paidList[index].paid[i].isPaid) {
          this.paidList[index].paid[i].value = e.target.checked;
        }
      }
      console.log(this.paidList);
    },
    allSetPaid(index) {
      return this.paidList[index].paid.every(
        (v) => v.isPaid === true || v.value === true
      );
    },
    allPaid(index) {
      return this.paidList[index].paid.every((v) => v.isPaid === true);
    },
    removeInvoice(index) {
      console.log("removing-index: ", index);
      this.selectedInvoice.splice(index, 1);
      this.paidList.splice(index, 1);
    },
    numberComma(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async submitForm() {
      this.isLoading = true;
      if (this.selectedInvoice.length > 0) {
        let paidTask = [];
        for (let i = 0; i < this.paidList.length; i++) {
          let appendTask = {
            invoice_id: this.selectedInvoice[i].taskToinvoice[0].invoice_id,
            task: [],
          };
          console.log("append task", appendTask);
          for (let j = 0; j < this.paidList[i].paid.length; j++) {
            console.log("this is loop");
            if (this.paidList[i].paid[j].value === true) {
              appendTask.task.push({
                task_id: this.selectedInvoice[i].taskToinvoice[j].task_id,
              });
            }
          }
          if (appendTask.task.length > 0) {
            paidTask.push(appendTask);
          }
        }
        let price = 0;
        let calTax = 0;
        let net = 0;
        for (let i = 0; i < this.paidList.length; i++) {
          for (let j = 0; j < this.paidList[i].paid.length; j++) {
            if (this.paidList[i].paid[j].value === true) {
              price =
                price + this.selectedInvoice[i].taskToinvoice[j].task.price;
              calTax =
                calTax +
                (this.selectedInvoice[i].taskToinvoice[j].task.tax *
                  this.selectedInvoice[i].taskToinvoice[j].task.price) /
                  100;
              net =
                net +
                (this.selectedInvoice[i].taskToinvoice[j].task.price -
                  (this.selectedInvoice[i].taskToinvoice[j].task.price *
                    this.selectedInvoice[i].taskToinvoice[j].task.tax) /
                    100);
            }
          }
        }
        // console.log({
        //   detail_id: this.$store.getters["create/getCompanyName"].id,
        //   accounting_id: this.selectedAccoutingId,
        //   bankpayment_id: this.currentBank.bankpayment_id,
        //   price: price,
        //   tax: calTax,
        //   net: net,
        //   note: this.note,
        //   note_tax: this.noteTax,
        //   date: this.createDate,
        //   payment_method: this.payMethod,
        //   cheque_number: this.chequeNumber,
        //   cheque_date: moment(this.chequeDate).format("YYYY-MM-DD"),
        //   amount: this.amount,
        //   difference: this.difference,
        //   difference_value: this.differenceValue,
        //   invoice: paidTask,
        // });
        try {
          const res = await axios.post(
            `${baseUrl}/receipt/create`,
            {
              detail_id: this.$store.getters["create/getCompanyName"].id,
              accounting_id: this.selectedAccoutingId,
              bankpayment_id: this.currentBank.bankpayment_id,
              price: price,
              tax: calTax,
              net: net,
              note: this.note,
              note_tax: this.noteTax,
              date: moment(this.createDate).format("YYYY-MM-DD"),
              payment_method: this.payMethod,
              cheque_bank: this.chequeBank,
              cheque_number: this.chequeNumber,
              cheque_date: this.chequeDate,
              amount: this.amount,
              difference: this.difference,
              difference_value: this.differenceValue,
              invoice: paidTask,
              authorize: this.useAuthorize
                ? this.currentAccouting.authorize
                : null,
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          if (res.data.status === "success") {
            this.successText = "เพิ่มสำเร็จ";
            this.successModal = true;
            setTimeout(() => {
              this.successModal = false;
              this.$router.replace("/receipt");
            }, 1000);
          } else {
            const error = new Error("สร้างReceiptไม่สำเร็จ");
            throw error;
          }
        } catch (err) {
          alert(err);
        }
      } else {
        alert("ไม่มีInvoiceเพื่อสร้างReceipt");
      }
      this.isLoading = false;
    },
    async deleteInvoice() {
      const res = await axios.post(
        `${baseUrl}/invoice/delete?invoice_id=${this.$route.params.invoiceid}`,
        {},
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(res);
      this.$router.replace("/invoice");
    },
    async goBackPage() {
      this.$router.go(-1);
    },

    toggleDialog() {
      this.showDialog = !this.showDialog;
    },

    setSelectedInvoice() {
      this.$store.dispatch(
        "create/setSelectedInvoice",
        this.$refs.invoiceTable.getSelectedRowData()
      );
      this.toggleDialog();
    },
    setCompany() {
      this.$store.dispatch("create/setCompanyName", this.modalCompany);
      this.loadSubTable();
    },
    async setCurrentBankPaymentName() {
      //   this.currentBank = null;
      const getBank = await axios.get(
        `${baseUrl}/bankpayment/get/?acc_name=${this.selectedAccountName}`,
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      //   console.log(getBank);
      this.currentBankList = getBank.data.data;
    },
    setInitialBank() {
      this.currentBank = {
        bankpayment_id: this.currentMember.bankpayment.bankpayment_id,
        bank: this.currentMember.bankpayment.bank,
        acc_number: this.currentMember.bankpayment.acc_number,
      };
    },
    async setCurrentAccount() {
      for await (const acc of this.accountingList) {
        if (acc.accounting_id === this.selectedAccoutingId) {
          this.currentAccouting = acc;
          console.log(acc);
          break;
        }
      }
    },
    async setCurrentMember() {
      console.log("setcurrentmember");
      console.log(this.selectedInvoice);
      // NOTE แก้ detail_id ตรงนี้ด้วย
      const member = await axios.get(
        // `${baseUrl}/member/get?detail_id=${this.$store.getters["create/getCompanyName"].id}`,
        `${baseUrl}/member/get?detail_id=${this.selectedInvoice[0].taskToinvoice[0].detail_id}`,
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      this.currentMember = member.data.data;
      if (this.currentMember) {
        console.log("this.currentMember", this.currentMember);
        // NOTE แก้ตรงนี้ถ้าไม่เอา default ผู้รับเงิน
        if (this.$store.getters["create/getSelectedInvoice"].length === 1) {
          this.selectedAccoutingId = this.selectedInvoice[0].accounting_id;
        } else {
          this.selectedAccoutingId = this.currentMember.accounting.accounting_id;
        }
        this.selectedAccountName = this.currentMember.bankpayment.acc_name;
        this.modalCompany = {
          name: this.currentMember.company_name,
          id: this.currentMember.detail_id,
        };
        this.setCompany();
        this.setCurrentBankPaymentName();
        this.setInitialBank();
      } else {
        alert("ไม่พบสมาชิกนี้");
        this.$router.replace("/invoice");
      }
    },
    async loadSubTable() {
      let sendMonth = null;
      if (this.monthSelected < 10) {
        sendMonth = `0${this.monthSelected}`;
      } else {
        sendMonth = this.monthSelected;
      }
      await this.$store.dispatch("general/getSubTable", {
        path: "third_popup",
        month: sendMonth,
        year: this.yearSelected,
      });
    },
    async loadData() {
      this.isLoading = true;
      const accounting = await axios.get(`${baseUrl}/accounting/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.accountingList = accounting.data.data;
      const bankPayment = await axios.get(`${baseUrl}/bankpayment/get/`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.bankPaymentList = bankPayment.data.data;
      const member = await axios.get(`${baseUrl}/member/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.memberList = member.data.data;
      await this.setCurrentMember();
      this.setCurrentAccount();
      this.isLoading = false;
    },
    taskDateFormat(name, date) {
      if (
        [
          "ค่าสอบบัญชี",
          "ค่าบริการงานบัญชีและปิดงบการเงินประจำปี",
          "ค่าบริการงานบัญชีประจำปี",
          "ค่าบริการจัดหาผู้สอบบัญชี",
        ].includes(name)
      ) {
        return `ปี ${moment(date).format("YYYY")}`;
      }
      if (
        [
          "ค่าบริการงานทะเบียน",
          "ค่าบริการจดทะเบียนบริษัท",
          "ค่าบริการคัดหนังสือรับรองและสำเนาเอกสาร",
          "ค่า Messenger",
        ].includes(name)
      ) {
        return "";
      }
      return `เดือน ${moment(date).format("MM/YYYY")}`;
    },
    setPaidList() {
      let list = [];
      for (const invoice of this.selectedInvoice) {
        let newList = {
          paid: [],
        };
        for (const task of invoice.taskToinvoice) {
          if (task.task.isPaid) {
            newList.paid.push({ value: false, isPaid: true });
          } else {
            newList.paid.push({ value: true, isPaid: false });
          }
        }
        list.push(newList);
        console.log(list);
      }
      this.paidList = list;
    },
  },
  beforeMount() {
    this.setPaidList();
    // console.log("selected", this.selectedInvoice[0]);
    // this.modalCompany = {
    //   name: this.selectedInvoice[0].company_name,
    //   id: this.selectedInvoice[0].taskToinvoice[0].detail_id,
    // };
    // console.log("modal company", this.modalCompany);
    // this.setCompany();
    // this.setCurrentAccount();
  },
  created() {
    if (this.$store.getters["create/getSelectedInvoice"].length <= 0) {
      this.$router.replace("/receipt");
    }
    this.loadData();
    // if (!this.$store.getters["create/getCompanyName"].id) {
    //   this.$router.replace("/task");
    // } else {
    //   this.modalCompany = this.$store.getters["create/getCompanyName"];
    // }
    // this.modalCompany = this.$store.getters["create/getCompanyName"];
  },
  updated() {
    // this.setCurrentAccount();
  },
};
</script>

<style scoped>
p {
  color: #ffffff;
}

h2,
h4 {
  color: #dddddd;
}

h4 {
  font-size: 18px;
}

input[type="number"],
input[type="text"],
input[type="button"],
select,
textarea {
  border-radius: 2px;
  background: #3a3f51;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

textarea {
  padding-top: 5px;
}

select,
input[type="number"],
input[type="button"],
input[type="text"] {
  height: 34px;
  min-width: 0;
}

input[type="number"] {
  text-align: right;
}

input[type="text"]:disabled,
input[type="button"]:disabled,
input[type="number"]:disabled,
textarea:disabled {
  color: #999da6;
  background-color: #404455;
}

.card {
  background-color: #4e5363;
  border-radius: 5px;
  padding: 10px 35px;
}

.box {
  padding: 27px;
  border: 1px solid #3a3f51;
  border-radius: 5px;
}

.partition {
  padding-bottom: 30px;
  margin-bottom: 40px;
  border-bottom: 1px solid #3e3e41;
}

.task-table {
  border: 1px solid #3e3e41;
  border-radius: 5px;
}

.table-header {
  border: 1px solid #3a3f51;
  border-radius: 5px 5px 0 0;
  background-color: #3a3f51;
  padding: 10px;
}

.table-info {
  border: 1px solid #3a3f51;
  border-radius: 0 0 5px 5px;
  background-color: #4e5363;
  padding: 0 10px 10px 10px;
  margin-bottom: 20px;
}

.table-item {
  padding: 10px 0;
  border-bottom: 1px solid #3a3f51;
}

.bin-icon {
  text-align: center;
  width: 22px;
  height: 22px;
  border-radius: 7px;
  border: solid 1px #ff4a3d;
  cursor: pointer;
}

.summary {
  background-color: #3a3f51;
  border-radius: 5px;
  padding: 20px 26px;
}

#summary-input {
  text-align: right;
  border: solid 0.5px #ffffff;
  padding: 0 10px;
}

#summary-select {
  background-color: #ededed;
  color: #3a3f51;
  width: 80%;
}

.add-file {
  background-color: #3a3f51;
  border-radius: 5px;
  width: 109.5px;
  height: 109.5px;
  cursor: pointer;
}

.modal-select {
  background-color: #4e5363;
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.task-no {
  background-color: #5f51f9;
  text-align: center;
  border-radius: 5px;
  padding: 5px 15px;
  margin: 10px 0px;
}

.input-box {
  font-size: 17px;
  width: 120px;
  text-align: right;
  color: #ffffff;
  background: #3a3f51;
  border-color: transparent;
}
</style>
